import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'

import Footer from '../components/maketApp/site/Footer'
import Contact from '../components/maketApp/site/Contact'
import { useParams } from 'react-router-dom'
import FormulaireCandidature from '../components/maketApp/site/FormulaireCandidature'
import HerosPostule from '../components/maketApp/site/HerosPostule'

const PostulerPages = () => {
    const { titre, id } = useParams();

  return (
    <div>
       <Navbar />
   
   <HerosPostule />
        <FormulaireCandidature offreId={id}  titre={titre} onSuccess={(result) => {
        console.log('Candidature créée, ID :', result.candidatureId);
      }} />
     
         <Footer />
    </div>
  )
}

export default PostulerPages
